"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
var _Icon = _interopRequireDefault(require("../Icon"));
var _cuid = _interopRequireDefault(require("cuid"));
var SmileySad = function SmileySad(props) {
  var uniqueId = (0, _cuid["default"])();
  return /*#__PURE__*/_react["default"].createElement(_Icon["default"], (0, _extends2["default"])({
    uniqueId: uniqueId
  }, props), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M13.055 8.47233C13.8983 8.47233 14.5827 7.78799 14.5827 6.94466C14.5827 6.10066 13.8983 5.41699 13.055 5.41699C12.211 5.41699 11.5273 6.10066 11.5273 6.94466C11.527 7.78766 12.2107 8.47233 13.055 8.47233Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M6.94368 8.47233C7.78701 8.47233 8.47135 7.78799 8.47135 6.94466C8.47135 6.10066 7.78701 5.41699 6.94368 5.41699C6.09968 5.41699 5.41602 6.10066 5.41602 6.94466C5.41602 7.78766 6.09968 8.47233 6.94368 8.47233Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10.0008 10C7.84747 10 5.78647 11.459 4.9898 13.5477C4.83947 13.942 5.03714 14.3833 5.43147 14.533C5.5208 14.5673 5.61247 14.5843 5.70347 14.5843C6.01047 14.5843 6.3008 14.397 6.4168 14.0923C6.99347 12.582 8.46714 11.528 10.0011 11.528C11.5335 11.528 13.0071 12.582 13.5838 14.0907C13.7341 14.4847 14.1775 14.6827 14.5698 14.5313C14.9638 14.3807 15.1611 13.9393 15.0105 13.5453C14.2128 11.4583 12.1528 10 10.0008 10Z"
  }), /*#__PURE__*/_react["default"].createElement("path", {
    d: "M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM10 19C5.03733 19 1 14.9627 1 10C1 5.03733 5.03733 1 10 1C14.9627 1 19 5.03733 19 10C19 14.9627 14.9627 19 10 19Z"
  }));
};
var _default = exports["default"] = SmileySad;